(() => {
  function setup(section) {
    const root = section.querySelector('[data-product-root]');
    if (!root || root._disposeProduct) return;
    const controller = new AbortController(), {signal} = controller;
    const listen = (node, type, fn, opts = {}) => node?.addEventListener(type, fn, {...opts, signal});
    const track = root.querySelector('[data-product-track]');
    const allSlides = [...root.querySelectorAll('[data-product-media]')];
    const slides = allSlides;
    let slide = 0;
    const count = root.querySelector('[data-product-count]');
    const status = root.querySelector('[data-product-status]');
    const mobile = matchMedia('(max-width: 989px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const say = message => { if (status) status.textContent = message; };
    function show(index, scroll = true) {
      if (!slides.length) return;
      slide = (index + slides.length) % slides.length;
      if (count) count.textContent = `${slide + 1} / ${slides.length}`;
      if (scroll && mobile.matches && track) track.scrollTo({left:slides[slide].offsetLeft - slides[0].offsetLeft,behavior:reduced.matches ? 'instant' : 'smooth'});
    }
    listen(root.querySelector('[data-product-prev]'), 'click', () => show(slide - 1));
    listen(root.querySelector('[data-product-next]'), 'click', () => show(slide + 1));
    let galleryFrame;
    listen(track, 'scroll', () => {
      cancelAnimationFrame(galleryFrame);
      galleryFrame = requestAnimationFrame(() => {
        if (!mobile.matches || !slides.length) return;
        const left = track.getBoundingClientRect().left;
        const index = slides.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        show(index, false);
      });
    }, {passive:true});
    const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
    const selects = [...root.querySelectorAll('[data-option-index]')];
    const id = root.querySelector('[data-variant-id]');
    const buy = root.querySelector('[data-add-to-cart]');
    const mobileBuy = root.querySelector('[data-mobile-add]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const inlinePrice = root.querySelector('[data-mobile-price-inline]');
    const checkout = root.querySelector('[data-dynamic-checkout]');
    const form = root.querySelector('.sb-product-form');
    const shopNow = root.querySelector('[data-shop-now]');
    const errorBox = root.querySelector('[data-product-error]');
    let checkoutPending = false;
    const quantity = root.querySelector('[data-quantity]');
    const input = quantity?.querySelector('input');
    function clampQuantity() {
      if (!input) return;
      const min = Number(input.min) || 1, step = Number(input.step) || 1;
      const max = input.max === '' ? Infinity : Number(input.max);
      const aligned = min + Math.max(0,Math.round(((Number(input.value) || min) - min) / step)) * step;
      input.value = Math.min(max, Math.max(min, aligned));
    }
    function variantChanged(updateUrl = false) {
      const values = selects.map(select => select.value);
      let current = selects.length ? variants.find(item => item.options.every((value,index) => value === values[index])) : variants.find(item => String(item.id) === id?.value);
      if (!selects.length && !current) current = variants[0];
      if (id) id.value = current ? current.id : '';
      if (mobilePrice) mobilePrice.textContent = '';
      if (inlinePrice) inlinePrice.textContent = '';
      let priceText = '';
      root.querySelectorAll('[data-variant-price]').forEach(price => {
        price.hidden = !current || price.dataset.variantPrice !== String(current.id);
        if (!price.hidden) {
          priceText = price.textContent.trim();
          if (mobilePrice) mobilePrice.textContent = priceText;
          if (inlinePrice) inlinePrice.textContent = priceText;
        }
      });
      const available = Boolean(current?.available);
      const label = available ? root.dataset.addText : current ? root.dataset.soldText : 'Unavailable';
      if (buy) { buy.disabled = !available || checkoutPending; buy.querySelector('[data-add-label]').textContent = label; }
      if (mobileBuy) { mobileBuy.disabled = !available || checkoutPending; mobileBuy.textContent = label; }
      if (checkout) checkout.hidden = !available;
      if (shopNow) shopNow.disabled = !available || checkoutPending;
      const specs = root.querySelector('[data-variant-specs]');
      if (specs) { specs.textContent = current?.title === 'Default Title' ? '' : current?.title || ''; specs.hidden = !specs.textContent; }
      if (input && current) {
        input.min = current.quantity_rule?.min || 1;
        input.step = current.quantity_rule?.increment || 1;
        if (current.quantity_rule?.max != null) input.max = current.quantity_rule.max;
        else input.removeAttribute('max');
        clampQuantity();
      }
      if (updateUrl) say(current ? `${priceText}. ${available ? 'Selected variant available.' : 'Selected variant sold out.'}` : 'The selected options are unavailable.');
      if (updateUrl && window.history.replaceState && !window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        if (current) url.searchParams.set('variant',current.id); else url.searchParams.delete('variant');
        history.replaceState(history.state,'',url.toString());
      }
      const target = allSlides.find(item => item.dataset.mediaId === String(current?.featured_media?.id));
      show(target ? Math.max(0,slides.indexOf(target)) : 0, updateUrl);
      if (!updateUrl && target && mobile.matches && track) requestAnimationFrame(() => { if (!signal.aborted) track.scrollTo({left:target.offsetLeft - slides[0].offsetLeft,behavior:'instant'}); });
      scheduleLayout();
    }
    selects.forEach(select => listen(select, 'change', () => variantChanged(true)));
    const changeQuantity = direction => {
      if (!input) return;
      input.value = (Number(input.value) || Number(input.min) || 1) + direction * (Number(input.step) || 1);
      clampQuantity(); input.dispatchEvent(new Event('change',{bubbles:true}));
    };
    listen(quantity?.querySelector('[data-quantity-minus]'), 'click', () => changeQuantity(-1));
    listen(quantity?.querySelector('[data-quantity-plus]'), 'click', () => changeQuantity(1));
    listen(mobileBuy, 'click', () => { if (form && !mobileBuy.disabled) form.requestSubmit(buy); });
    // Native Add to cart remains unchanged. Shop now adds the current form selection,
    // then enters Shopify checkout without clearing an existing cart.
    listen(form, 'submit', async event => {
      if (checkoutPending) { event.preventDefault(); return; }
      if (!shopNow || event.submitter !== shopNow) { say('Adding your selection to the cart…'); return; }
      event.preventDefault();
      if (!form.reportValidity() || shopNow.disabled) return;
      const body = new FormData(form);
      body.delete('return_to');
      checkoutPending = true;
      shopNow.disabled = true;
      buy.disabled = true;
      if (mobileBuy) mobileBuy.disabled = true;
      form.setAttribute('aria-busy', 'true');
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      say('Preparing your checkout…');
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {method:'POST', headers:{Accept:'application/json'}, body});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This selection could not be added. Please check the quantity and availability.');
        say('Selection added. Opening checkout…');
        window.location.assign(root.dataset.checkoutUrl);
      } catch (error) {
        const message = error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message;
        if (errorBox) { errorBox.textContent = message; errorBox.hidden = false; }
        [input,...selects].forEach(field => { if (field && errorBox) field.setAttribute('aria-describedby',errorBox.id); });
        say(message);
      } finally {
        checkoutPending = false;
        form.removeAttribute('aria-busy');
        variantChanged();
      }
    });
    const share = root.querySelector('[data-share-product]');
    listen(share, 'click', async () => {
      try {
        const url = new URL(root.dataset.productUrl, location.origin);
        if (id?.value) url.searchParams.set('variant',id.value);
        if (navigator.share) await navigator.share({title:share.dataset.shareTitle,url:url.href});
        else { await navigator.clipboard.writeText(url.href); share.querySelector('span').textContent = root.dataset.copiedText; say(root.dataset.copiedText); }
      } catch (error) { if (error.name !== 'AbortError') say(root.dataset.copyErrorText); }
    });
    const stickyBar = root.querySelector('[data-mobile-buy]');
    const info = root.querySelector('.sb-info');
    let layoutFrame;
    const isVisible = node => node && !node.closest('[hidden]') && getComputedStyle(node).display !== 'none' && node.getBoundingClientRect().height > 0;
    function layout() {
      if (track) track.tabIndex = mobile.matches ? 0 : -1;
      const headerBottom = Math.max(0,...[...document.querySelectorAll('#skNav, #shopify-section-header, .shopify-section-group-header-group, header.header')].map(node => {
        const rect = node.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < innerHeight ? Math.min(rect.bottom,innerHeight / 2) : 0;
      }));
      const availableTop = headerBottom;
      const infoHeight = info?.getBoundingClientRect().height || 0;
      // Keep the column sticky throughout the gallery. Exceptionally long copy
      // can move up until the final purchase controls fit, without a nested scroll area.
      const stickyTop = Math.min(availableTop, innerHeight - infoHeight - 16);
      root.removeAttribute('data-purchase-flow');
      root.style.setProperty('--pdp-sticky-top', Math.round(stickyTop) + 'px');
      if (!stickyBar || !buy) return;
      const footer = document.querySelector('#shopify-section-footer, .shopify-section-group-footer-group, footer');
      const banner = [...document.querySelectorAll('[data-cookie-banner],.cookie-banner,#shopify-privacy-banner,dialog[open]')].some(isVisible);
      const editingElsewhere = document.activeElement?.matches('input,textarea,select,[contenteditable=true]') && !root.contains(document.activeElement);
      const shortViewport = (window.visualViewport?.height || innerHeight) < 480;
      const shouldShow = mobile.matches && buy.getBoundingClientRect().bottom < 0 && !(footer && footer.getBoundingClientRect().top < innerHeight) && !banner && !editingElsewhere && !shortViewport && !document.hidden;
      if (stickyBar.hidden !== !shouldShow) stickyBar.hidden = !shouldShow;
      stickyBar.toggleAttribute('data-visible',shouldShow);
      document.body.classList.toggle('pdp-mobile-bar-visible',shouldShow);
      const height = shouldShow ? Math.ceil(stickyBar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--pdp-mobile-bar-height',height + 'px');
    }
    function scheduleLayout() { cancelAnimationFrame(layoutFrame); layoutFrame = requestAnimationFrame(layout); }
    listen(window, 'scroll', scheduleLayout, {passive:true});
    listen(window, 'resize', scheduleLayout, {passive:true});
    listen(window.visualViewport, 'resize', scheduleLayout, {passive:true});
    listen(document, 'visibilitychange', scheduleLayout);
    listen(document, 'focusin', scheduleLayout);
    listen(document, 'focusout', scheduleLayout);
    listen(mobile, 'change', () => { show(slide); scheduleLayout(); });
    const sizeObserver = new ResizeObserver(scheduleLayout);
    if (info) sizeObserver.observe(info);
    if (stickyBar) sizeObserver.observe(stickyBar);
    document.querySelectorAll('#skNav, #shopify-section-header, .shopify-section-group-header-group, header.header').forEach(node => sizeObserver.observe(node));
    const mutationObserver = new MutationObserver(records => {
      // Ignore our own layout styles while detecting cookie/dialog visibility changes.
      if (records.some(record => record.type === 'childList' || ['hidden','open'].includes(record.attributeName) || record.target.matches?.('[data-cookie-banner],.cookie-banner,#shopify-privacy-banner,dialog'))) scheduleLayout();
    });
    mutationObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden','open','class','style']});
    root._disposeProduct = () => {
      controller.abort(); sizeObserver.disconnect(); mutationObserver.disconnect();
      cancelAnimationFrame(layoutFrame); cancelAnimationFrame(galleryFrame);
      document.body.classList.remove('pdp-mobile-bar-visible');
      document.documentElement.style.removeProperty('--pdp-mobile-bar-height');
      delete root._disposeProduct;
    };
    variantChanged(); layout();
  }
  document.querySelectorAll('#MainContent .shopify-section').forEach(setup);
  document.addEventListener('shopify:section:load',event => setup(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelector('[data-product-root]')?._disposeProduct?.());
})();
